import React from "react";
import { IImage, ILink } from "@/src/types";
import Title from "@/components/Title/Title";
import S from "./DoubleImageWithText.style";
import ArrowButtonWhite from "../../../images/ArrowButtonWhite.png";
import { Wysiwyg } from "@/styles/typography";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { getCopy } from '@/src/helpers';

export interface Props {
  image1: IImage;
  image2: IImage;
  image3?: IImage;
  image1Link: ILink;
  image2Link: ILink;
  image3Link?: ILink;
  image1Subtitle: string;
  image2Subtitle: string;
  image3Subtitle?: string;
  activateImage3: string;
  text: string;
  title: string;
}

const DoubleImageWithText: React.FC<Props> = ({
  image1,
  image2,
  image1Link,
  image2Link,
  image1Subtitle,
  image2Subtitle,
  text,
  title,
  image3,
  image3Link,
  image3Subtitle,
  activateImage3,
}) => {
  // Gatsby Image
  const imageData1 = image1.gatsbyImage ? getImage(image1.gatsbyImage) : null;
  const imageData2 = image2.gatsbyImage ? getImage(image2.gatsbyImage) : null;
  const imageData3 = image3?.gatsbyImage ? getImage(image3.gatsbyImage) : null;

  return (
    <div className="main-inner">
      <S.Container>
        <S.TextWrapper>
          <Title title={title} fontSize="h2" />
          {text && (
            <Wysiwyg color="#000" dangerouslySetInnerHTML={{ __html: text }} />
          )}
        </S.TextWrapper>
        <S.ImagesWrapper>
          <S.ImageContainer href={image1Link.url} target={image1Link.target}>
            {imageData1 && (
              <>
                <S.ImageOverlay />
                <GatsbyImage
                  className="gatsby-image"
                  image={imageData1}
                  alt={image1.altText}
                />
                <S.P className="custom-spacing">&copy; {image1?.caption ? image1.caption.replace(/[<p>|</p>]/g, '') : getCopy(image1.altText, image1.sourceUrl)}{' '}</S.P>
              </>
            )}
            <S.ImageText className="text-animation-one">
              {image1Link && (
                <>
                  <S.Link>
                    {image1Link.title}
                    <S.Line />
                  </S.Link>
                </>
              )}
              {image1Subtitle && (
                <S.SubtitleWrapper>
                  <S.Subtitle>{image1Subtitle}</S.Subtitle>
                  <img src={ArrowButtonWhite} alt="arrow" />
                </S.SubtitleWrapper>
              )}
            </S.ImageText>
          </S.ImageContainer>
          <S.ImageContainer href={image2Link.url} target={image2Link.target}>
            {imageData2 && (
              <>
                <S.ImageOverlay />
                <GatsbyImage
                  className="gatsby-image"
                  image={imageData2}
                  alt={image2.altText}
                />
                <S.P className="">&copy; {image2?.caption ? image2?.caption.replace(/[<p>|</p>]/g, '') : getCopy(image2.altText, image2.sourceUrl)}{' '}</S.P>
              </>
            )}
            <S.ImageText>
              {image2Link && (
                <>
                  <S.Link>
                    {image2Link.title}
                    <S.Line />
                  </S.Link>
                </>
              )}
              {image2Subtitle && (
                <S.SubtitleWrapper>
                  <S.Subtitle>{image2Subtitle}</S.Subtitle>
                  <img src={ArrowButtonWhite} alt="arrow" />
                </S.SubtitleWrapper>
              )}
            </S.ImageText>
          </S.ImageContainer>
          {activateImage3 === "yes" && (
            <>
              {image3Link && (
                <S.ImageContainer
                  href={image3Link.url}
                  target={image3Link.target}
                >
                  {imageData3 && image3 && (
                    <>
                      <S.ImageOverlay />
                      <GatsbyImage
                        className="gatsby-image"
                        image={imageData3}
                        alt={image3.altText}
                      />
                      <S.P className="">&copy; {image3?.caption ? image3?.caption.replace(/[<p>|</p>]/g, '') : getCopy(image3.altText, image3.sourceUrl)}{' '}</S.P>
                    </>
                  )}
                  <S.ImageText>
                    {image3Link && (
                      <>
                        <S.Link>
                          {image3Link.title}
                          <S.Line />
                        </S.Link>
                      </>
                    )}
                    {image3Subtitle && (
                      <S.SubtitleWrapper>
                        <S.Subtitle>{image3Subtitle}</S.Subtitle>
                        <img src={ArrowButtonWhite} alt="arrow" />
                      </S.SubtitleWrapper>
                    )}
                  </S.ImageText>
                </S.ImageContainer>
              )}
            </>
          )}
        </S.ImagesWrapper>
      </S.Container>
    </div>
  );
};

export default DoubleImageWithText;
